import React from 'react'

const Privacy = () => {
    return (
        <div id='privacy'>
            <h1>Privacy Policy</h1>
            <p>Last Updated: 2/10/2025</p>

            <h2>1. Information We Collect</h2>
            <p>
                We do not collect personal data unless voluntarily provided by users, such as contact forms or email subscriptions.
            </p>

            <h2>2. How We Use Information</h2>
            <p>
                Any information collected is used to improve our services and respond to inquiries. We do not sell or share user data with third parties.
            </p>

            <h2>3. Cookies</h2>
            <p>
                This Site may use cookies to enhance the user experience. You can disable cookies in your browser settings.
            </p>

            <h2>4. Third-Party Services</h2>
            <p>
                We may use third-party tools (such as Google Analytics) to understand site usage. These tools may collect anonymized data.
            </p>

            <h2>5. Security</h2>
            <p>
                We implement security measures to protect user data, but no method of transmission over the internet is 100% secure.
            </p>

            <h2>6. Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Users will be notified of significant changes.
            </p>

            <h2>7. Contact Information</h2>
            <p>
                If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@alphabuilders-wa.com">support@alphabuilders-wa.com</a>.
            </p>
        </div>
    )
}

export default Privacy